import { OptionListOption } from '@gaiads/telia-react-component-library';

export const COUNTRY_OPTIONS: OptionListOption[] = [
  { value: '', label: '' },
  { value: 'NO', label: 'Norway' },
];

export const DEFAULT_PAGE_SIZE = 10;

export const IMPORT_USERS_FLOW_CONSTANTS = {
  uploadTemplate: 'upload-template',
  reviewAndSave: 'review-and-save',
  summary: 'summary',
};

export const VERIFY_PASSCODE = /^\d{6}$/;

export type SupportedLanguage = 'en' | 'no';

export const API_ERROR_AUTH_FAILED = {
  statusCode: 401,
  errorMessage: 'authentication_failed',
};

export const DATE_AND_TIME_FORMAT = 'dd.LL.yyyy HH:mm';

// Add feature flags here. The keys need to match with names used in backend
export interface FeatureFlags {
  FEATURE_FLAG_CIAM_MFA_ENABLED: boolean;
  FEATURE_FLAG_FILTER_ASSETS_WAITING_FOR_RETURN_ENABLED: boolean;
  FEATURE_FLAG_FRONTEND_FLOW_BUYOUT_WITH_PRICE_ENABLED: boolean;
  FEATURE_FLAG_MAINTENANCE_MODE_ENABLED: boolean;
  FEATURE_FLAG_MAINTENANCE_MODE_SHOP_ENABLED: boolean;
  FEATURE_FLAG_PIM_AND_USER_GROUP_ROLES_ENABLED: boolean;
  FEATURE_FLAG_RECURRING_MONTHLY_EXTENSION_NO_ENABLED: boolean;
  FEATURE_FLAG_USER_OFFBOARDING_ENABLED: boolean;
}

export const defaultFeatureFlags: FeatureFlags = {
  FEATURE_FLAG_CIAM_MFA_ENABLED: false,
  FEATURE_FLAG_FILTER_ASSETS_WAITING_FOR_RETURN_ENABLED: false,
  FEATURE_FLAG_FRONTEND_FLOW_BUYOUT_WITH_PRICE_ENABLED: false,
  FEATURE_FLAG_MAINTENANCE_MODE_ENABLED: false,
  FEATURE_FLAG_MAINTENANCE_MODE_SHOP_ENABLED: false,
  FEATURE_FLAG_PIM_AND_USER_GROUP_ROLES_ENABLED: false,
  FEATURE_FLAG_RECURRING_MONTHLY_EXTENSION_NO_ENABLED: false,
  FEATURE_FLAG_USER_OFFBOARDING_ENABLED: false,
};
